import React from "react";
import NavbarOnboarding from "../navbarOnboarding/NavbarOnboarding";

//Styles
import styles from "./entryPages.module.css";

function EntryPages({ children, name, backButton }) {
  return (
    <div className={styles.container}>
      <NavbarOnboarding name={name} backButton={backButton} />
      <div>{children}</div>
    </div>
  );
}

export default EntryPages;
